/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Table } from "semantic-ui-react";
import { selectEditMode } from "../slices/editMode/editModeSlice";
import { resourceUpdated, selectResourceById } from "../slices/resourceCollection/resourceCollectionSlice";
import { selectAllResourceChanges } from "../slices/resourceChangeReport/resourceChangeReportSlice";
import StringEntry from "../datatypeComponents/StringEntry";
import ArrayEntry from "../datatypeComponents/ArrayEntry";
import { TextField } from "@mui/material";
import { updateCodeSystemConceptElement } from "../functions/updateElement";
import CodeEntry from "../datatypeComponents/CodeEntry";
import { languageCodes } from "../dictionaries/CodeSystemLookup";
import BooleanEntry from "../datatypeComponents/BooleanEntry";
import updateChangeReport from "../slices/resourceChangeReport/updateChangeReport";
import {
    changeConceptDelete, changeNewChildConcepts, changeSubmitNewChildConcepts,
    changeSubmitNewTopLevelConcepts, changeTermChanged, selectConceptDelete, selectConceptName,
    selectConceptPath, selectConceptPathIndexes, selectConceptSelected,
    selectNewChildConcepts, selectSubmitNewChildConcepts, selectSubmitNewTopLevelConcepts
} from "../slices/codeSystemTermDetail/codeSystemTermDetailSlice";

const ChildConceptsTable = ({ resourceId }) => {

    const parentResourceDetail = useSelector(state => selectResourceById(state, resourceId));
    const resourceJson = parentResourceDetail?.revisedResourceJson;
    const dispatch = useDispatch();
    const conceptSelected = useSelector(selectConceptSelected);
    const newChildConcepts = useSelector(selectNewChildConcepts);
    const conceptPath = useSelector(selectConceptPath);

    const [headerState, setHeaderState] = useState("");
    const [conceptState, setConceptState] = useState({});
    const [addButtonTextState, setAddButtonTextState] = useState("");

    useEffect(() => {
        let header = "Child concepts:";
        let addButtonText = "+ Add Child Concept";
        let concept;
        if (conceptSelected) {
            concept = JSON.parse(JSON.stringify(conceptSelected));
        }
        if (conceptPath === undefined || conceptPath.length === 0) {
            concept = resourceJson;
            header = "Top-level concepts:"
            addButtonText = "+ Add Top-Level Concept";
        }
        setConceptState(concept);
        setHeaderState(header);
        setAddButtonTextState(addButtonText);
    }, [conceptSelected]);

    return <>
        {newChildConcepts && <>
            <b>{headerState}</b>
            {(conceptState?.concept?.length > 0 || newChildConcepts?.length > 0) &&
                <div>
                    <Table>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Code</Table.HeaderCell>
                                <Table.HeaderCell>Display</Table.HeaderCell>
                                <Table.HeaderCell>Definition</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {conceptState?.concept?.map((subConcept, subConceptIndex) => {
                                return <Table.Row key={subConceptIndex}>
                                    <Table.Cell>{subConcept.code}</Table.Cell>
                                    <Table.Cell>
                                        {/*<a href={`/resources/CodeSystem/${resourceId}#${subConcept.code}`}>*/}
                                        {subConcept.display}
                                        {/*</a>*/}
                                    </Table.Cell>
                                    <Table.Cell>{subConcept.definition}</Table.Cell>
                                </Table.Row>
                            })}
                            {newChildConcepts?.map((newConcept, newConceptIndex) => {
                                return <Table.Row key={newConceptIndex}>
                                    <Table.Cell>
                                        <TextField style={{ width: "100%" }} multiline
                                            className="inputField" type='text' label={'Code'}
                                            size="small" variant='outlined'
                                            value={newConcept["code"] || ''}
                                            onChange={(e) => {
                                                let newNewChildConcepts = JSON.parse(JSON.stringify(newChildConcepts));
                                                newNewChildConcepts[newConceptIndex]["code"] = e.target.value;
                                                dispatch(changeNewChildConcepts(newNewChildConcepts));
                                            }} />
                                    </Table.Cell>
                                    <Table.Cell>
                                        <TextField style={{ width: "100%" }} multiline
                                            className="inputField" type='text' label={'Display'}
                                            size="small" variant='outlined'
                                            value={newConcept["display"] || ''}
                                            onChange={(e) => {
                                                let newNewChildConcepts = JSON.parse(JSON.stringify(newChildConcepts));
                                                newNewChildConcepts[newConceptIndex]["display"] = e.target.value;
                                                dispatch(changeNewChildConcepts(newNewChildConcepts));
                                            }} />
                                    </Table.Cell>
                                    <Table.Cell>
                                        <TextField style={{ width: "100%" }} multiline
                                            className="inputField" type='text' label={'Definition'}
                                            size="small" variant='outlined'
                                            value={newConcept["definition"] || ''}
                                            onChange={(e) => {
                                                let newNewChildConcepts = JSON.parse(JSON.stringify(newChildConcepts));
                                                newNewChildConcepts[newConceptIndex]["definition"] = e.target.value;
                                                dispatch(changeNewChildConcepts(newNewChildConcepts));
                                            }} />
                                    </Table.Cell>
                                </Table.Row>
                            })}
                        </Table.Body>
                    </Table>
                </div>
            }
            <span>
                <Button className="formButton" style={{ color: "#000000" }}
                    content={addButtonTextState}
                    onClick={() => {
                        let newNewChildConcepts = JSON.parse(JSON.stringify(newChildConcepts));
                        newNewChildConcepts.push({ "code": "", "display": "", "definition": "" });
                        dispatch(changeNewChildConcepts(newNewChildConcepts));
                    }} />
                &nbsp; &nbsp; &nbsp;
                {newChildConcepts.length > 0 &&
                    <Button className="formButton positive"
                        content="Submit"
                        onClick={() => {
                            if (headerState === "Top-level concepts:") {
                                dispatch(changeSubmitNewTopLevelConcepts(true));
                            } else {
                                dispatch(changeSubmitNewChildConcepts(true));
                            }
                        }}
                        disabled={newChildConcepts[0].code === "" &&
                            newChildConcepts[0].display === "" &&
                            newChildConcepts[0].definition === ""
                        } />
                }
            </span>
        </>}
    </>
};

const getCodeSystemProperties = (codeSystemTermState) => {
    let startingConceptProperty = {};
    if (Array.isArray(codeSystemTermState.property) && codeSystemTermState.property.length > 0) {
        for (const property of codeSystemTermState.property) {
            startingConceptProperty[property.code] = {
                valueCode: property.valueCode || null,
                valueCoding: property.valueCoding || null,
                valueString: property.valueString || null,
                valueInteger: property.valueInteger || null,
                valueBoolean: property.valueBoolean ?? null,
                valueDateTime: property.valueDateTime || null,
                valueDecimal: property.valueDecimal || null
            }
        }
    }
    return startingConceptProperty;
}

const CodeSystemConceptDesignationEntry = ({ elementName, fieldLabel, startingValue, setResourceState }) => {

    const [codeSystemConceptDesignationState, setCodeSystemConceptDesignationState] = useState({});
    const [addLanguageState, setAddLanguageState] = useState(false);

    useEffect(() => {
        let startingDesignation = {
            "language": "",
            "use": {
                "system": "http://snomed.info/sct",
                "code": "900000000000013009",
                "display": "Synonym (core metadata concept)"
            },
            "value": ""
        }
        if (startingValue) {
            if (startingValue.extension) { startingDesignation.extension = startingValue.extension; }
            if (startingValue.language) { startingDesignation.language = startingValue.language; }
            if (startingValue.use) { startingDesignation.use = startingValue.use; }
            if (startingValue.value) { startingDesignation.value = startingValue.value; }
        }
        if (startingDesignation.use.code === "900000000000003001") {
            startingDesignation.primaryTerm = true;
        }
        setCodeSystemConceptDesignationState(JSON.parse(JSON.stringify(startingDesignation)));
        setAddLanguageState(startingDesignation.language ? true : false);
    }, []);

    useEffect((() => {
        if (Object.keys(codeSystemConceptDesignationState).length > 0) {
            let newDesignation = {};
            if (codeSystemConceptDesignationState.extension) { newDesignation.extension = codeSystemConceptDesignationState.extension; }
            if (codeSystemConceptDesignationState.language) { newDesignation.language = codeSystemConceptDesignationState.language; }
            if (codeSystemConceptDesignationState.use) { newDesignation.use = codeSystemConceptDesignationState.use; }
            if (codeSystemConceptDesignationState.value) { newDesignation.value = codeSystemConceptDesignationState.value; }
            if (codeSystemConceptDesignationState.primaryTerm) {
                newDesignation.use = {
                    "system": "http://snomed.info/sct",
                    "code": "900000000000003001",
                    "display": "Fully specified name"
                }
            } else if (codeSystemConceptDesignationState.primaryTerm === false) {
                newDesignation.use = {
                    "system": "http://snomed.info/sct",
                    "code": "900000000000013009",
                    "display": "Synonym (core metadata concept)"
                }
            }
            if (Object.keys(newDesignation).length === 0) {
                newDesignation = null;
            }
            setResourceState(prevState => { return { ...prevState, [elementName]: newDesignation }; });
        }
    }), [codeSystemConceptDesignationState]);

    if (Object.keys(codeSystemConceptDesignationState).length > 0) {
        return <>
            <p style={{ marginBottom: "0px" }}><b>{fieldLabel}: </b></p>
            <div style={{ marginLeft: "24px" }}>
                <StringEntry elementName='value' fieldLabel='Alternative term'
                    startingValue={codeSystemConceptDesignationState.value}
                    setResourceState={setCodeSystemConceptDesignationState} />
                <span onClick={() => { setAddLanguageState(!addLanguageState) }} >
                    {addLanguageState ?
                        <>Collapse language</> :
                        <>{codeSystemConceptDesignationState.language ? <>Edit language</> : <>Add language</>}</>
                    }
                </span>
                {addLanguageState && <>
                    <CodeEntry elementName='language'
                        fieldLabel='Language Code (See https://build.fhir.org/valueset-languages.html)'
                        allowedValues={languageCodes}
                        startingValue={codeSystemConceptDesignationState.language}
                        setResourceState={setCodeSystemConceptDesignationState} />
                    {codeSystemConceptDesignationState.language &&
                        <BooleanEntry elementName='primaryTerm' fieldLabel='Primary Term?'
                            startingValue={codeSystemConceptDesignationState.primaryTerm}
                            setResourceState={setCodeSystemConceptDesignationState} />}
                </>}
            </div>
        </>
    }
}

const CodeSystemConceptDataEntry = ({ resourceId, codeSystemTermState, setCodeSystemTermState }) => {
    const dispatch = useDispatch();
    const parentResourceDetail = useSelector(state => selectResourceById(state, resourceId));
    const resourceJson = parentResourceDetail?.revisedResourceJson;

    const [conceptPropertyState, setConceptPropertyState] = useState(getCodeSystemProperties(codeSystemTermState));
    const [propertyEditedState, setPropertyEditedState] = useState(false);

    useEffect(() => {
        if (codeSystemTermState) {
            let conceptPropertyValues = getCodeSystemProperties(codeSystemTermState);
            setConceptPropertyState(conceptPropertyValues);
        }
    }, [codeSystemTermState]);

    useEffect(() => {
        if (propertyEditedState === true) {
            let newConceptProperty = [];
            for (const code in conceptPropertyState) {
                let instance = { "code": code };
                if (conceptPropertyState[code].valueString) {
                    instance.valueString = conceptPropertyState[code].valueString;
                } else if (conceptPropertyState[code].valueCode) {
                    instance.valueCode = conceptPropertyState[code].valueCode;
                } else if (conceptPropertyState[code].valueCoding) {
                    instance.valueCoding = conceptPropertyState[code].valueCoding;
                } else if (conceptPropertyState[code].valueInteger) {
                    instance.valueInteger = conceptPropertyState[code].valueInteger;
                } else if (conceptPropertyState[code].valueDecimal) {
                    instance.valueDecimal = conceptPropertyState[code].valueDecimal;
                } else if (conceptPropertyState[code].valueDateTime) {
                    instance.valueDateTime = conceptPropertyState[code].valueDateTime;
                } else if (typeof conceptPropertyState[code].valueBoolean === "boolean") {
                    instance.valueBoolean = conceptPropertyState[code].valueBoolean;
                } else {
                    instance.valueString = "";
                }
                newConceptProperty.push(instance);
            }

            if (JSON.stringify(codeSystemTermState.property) !== JSON.stringify(newConceptProperty)) {
                setCodeSystemTermState(prevState => { return { ...prevState, "property": newConceptProperty } });
            }
            setPropertyEditedState(false);
        }
    }, [conceptPropertyState]);

    return <>
        {(codeSystemTermState && Object.keys(codeSystemTermState).length > 0) &&
            <>
                <StringEntry elementName='code' fieldLabel='Code'
                    startingValue={codeSystemTermState.code} setResourceState={setCodeSystemTermState} />
                <StringEntry elementName='display' fieldLabel='Preferred term (Display)'
                    startingValue={codeSystemTermState.display} setResourceState={setCodeSystemTermState} />
                <StringEntry elementName='definition' fieldLabel='Definition'
                    startingValue={codeSystemTermState.definition} setResourceState={setCodeSystemTermState} />
                <ArrayEntry datatype='CodeSystemConceptDesignation'
                    startEmptyArrayClosed={true}
                    elementName='designation' fieldLabel='Alternative Term' deletable={true}
                    startingValue={codeSystemTermState.designation} setResourceState={setCodeSystemTermState} />
                <br /><br />
                {resourceJson.property?.length > 0 &&
                    <Table style={{ margin: "0px" }}>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell style={{ width: "30%" }}>Type of Property</Table.HeaderCell>
                                <Table.HeaderCell style={{ width: "70%" }}>Property Value</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {resourceJson.property.map((systemProperty, systemPropertyIndex) => {
                                return <Table.Row key={systemPropertyIndex}>
                                    <Table.Cell>{systemProperty.description}</Table.Cell>
                                    <Table.Cell>
                                        <TextField style={{ width: "100%" }} multiline className="inputField" type='text'
                                            label={'Value'} size="small" variant='outlined'
                                            value={conceptPropertyState[systemProperty.code]?.valueString || ""}
                                            onChange={(e) => {
                                                setConceptPropertyState(prevState => {
                                                    return {
                                                        ...prevState,
                                                        [systemProperty.code]: { valueString: e.target.value }
                                                    };
                                                });
                                                setPropertyEditedState(true);
                                            }} />
                                    </Table.Cell>
                                </Table.Row>
                            })}
                        </Table.Body>
                    </Table>
                }
                <br />
                <ChildConceptsTable resourceId={resourceId} />
                <br /><br />
                <div style={{ width: "100%" }}>
                    <Button style={{ color: "#000000", float: "right" }} className="formButton"
                        content="Delete Concept"
                        onClick={() => {
                            if (window.confirm("Are you sure you want to permanately remove the term \"" + codeSystemTermState.display + "\" and all related concepts including child concepts (if any)?")) {
                                setCodeSystemTermState(prevState => { return { ...prevState, "conceptDelete": true }; });
                                //TODO - see if this line can be deleted
                                dispatch(changeConceptDelete(true));
                                dispatch(changeTermChanged(true));
                            }
                        }} />
                </div>
                <br /><br />
            </>}
    </>
};

const getCodeSystemConceptValuesFromFhirJson = (resourceJson, codeSystemTermState,
    conceptSelected, conceptPathIndexes
) => {
    //For the CodeSystem Builder in the Term Detail tab
    //Gets the values from the FHIR JSON for a single concept (term) and returns the values to be used for the codeSystemTermState for display/editing in the Term Detail tab. It doesn't set the state in this function.

    let update = false; //Maybe make a better variable name
    let code = "TOP-level-so-no-code";
    let display = "";
    let definition = "";
    let designation = [];
    let property = [];
    let concept = [];

    let termJson = conceptSelected; //Maybe call it conceptJson, because it's the original FHIR JSON
    let codeSystemConceptValues = codeSystemTermState || {};
    if (codeSystemConceptValues.loaded === false || codeSystemConceptValues.loaded === undefined) {
        update = true;
    }

    if (JSON.stringify(codeSystemTermState.pathIndexes) !== JSON.stringify(conceptPathIndexes)) {
        update = true;
        if (termJson) {
            if (termJson.code) {
                code = termJson.code;
            }
            if (termJson.display) {
                display = termJson.display;
            }
            if (termJson.definition) {
                definition = termJson.definition;
            }
            if (termJson.designation) {
                designation = termJson.designation;
            }
            if (termJson.property) {
                property = termJson.property;
            }
            if (termJson.concept) {
                concept = termJson.concept;
            }
        }
    }
    if (termJson === undefined && resourceJson) {
        if (resourceJson.concept?.length > 0) {
            concept = resourceJson.concept;
        }
    }

    if (update) { //Then update the codeSystemConceptValues
        codeSystemConceptValues = {
            loaded: true,
            code: code,
            display: display,
            definition: definition,
            designation: designation,
            property: property,
            concept: concept,
            pathIndexes: conceptPathIndexes,
            termChanged: false
        };
    }
    return codeSystemConceptValues;
}

const CodeSystemTermEdit = ({ resourceId }) => {
    const dispatch = useDispatch();

    const editMode = useSelector(state => selectEditMode(state));
    const parentResourceDetail = useSelector(state => selectResourceById(state, resourceId));
    const resourceChanges = useSelector(state => selectAllResourceChanges(state));
    const resourceJson = parentResourceDetail?.revisedResourceJson;
    const conceptSelected = useSelector(selectConceptSelected);
    const conceptPath = useSelector(selectConceptPath);
    const conceptPathIndexes = useSelector(selectConceptPathIndexes);
    const newChildConcepts = useSelector(selectNewChildConcepts);
    const submitNewChildConcepts = useSelector(selectSubmitNewChildConcepts);
    const submitNewTopLevelConcepts = useSelector(selectSubmitNewTopLevelConcepts);
    const conceptDelete = useSelector(selectConceptDelete);
    const conceptName = useSelector(selectConceptName);

    const [codeSystemTermState, setCodeSystemTermState] = useState({});
    const [codeSystemTermConceptState, setCodeSystemTermConceptState] = useState([]);

    useEffect(() => {
        let startingCodeSystemTermState = getCodeSystemConceptValuesFromFhirJson(
            resourceJson,
            { loaded: false, termChanged: false, editChanged: false },
            conceptSelected, conceptPathIndexes
        );
        setCodeSystemTermState(startingCodeSystemTermState);
        setCodeSystemTermConceptState(startingCodeSystemTermState.concept);
    }, []);

    useEffect(() => {
        if (editMode && resourceJson && conceptPathIndexes && conceptPath.length > 0) {
            updateCodeSystemConceptElement(codeSystemTermState, conceptPathIndexes,
                "code", "code",
                parentResourceDetail, resourceChanges, dispatch, conceptSelected);
        }
    }, [codeSystemTermState.code]);

    useEffect(() => {
        if (editMode && resourceJson && conceptPathIndexes && conceptPath.length > 0) {
            updateCodeSystemConceptElement(codeSystemTermState, conceptPathIndexes,
                "display", "string",
                parentResourceDetail, resourceChanges, dispatch, conceptSelected)
        }
    }, [codeSystemTermState.display]);

    useEffect(() => {
        if (editMode && resourceJson && conceptPathIndexes && conceptPath.length > 0) {
            updateCodeSystemConceptElement(codeSystemTermState, conceptPathIndexes,
                "definition", "string",
                parentResourceDetail, resourceChanges, dispatch, conceptSelected)
        }
    }, [codeSystemTermState.definition]);

    useEffect(() => {
        if (editMode && resourceJson && conceptPathIndexes && conceptPath.length > 0) {
            updateCodeSystemConceptElement(codeSystemTermState, conceptPathIndexes,
                "designation", "ArrayOfCodeSystemDesignation",
                parentResourceDetail, resourceChanges, dispatch, conceptSelected)
        }
    }, [codeSystemTermState.designation]);

    useEffect(() => {
        if (editMode && resourceJson && conceptPathIndexes && conceptPath.length > 0) {
            updateCodeSystemConceptElement(codeSystemTermState, conceptPathIndexes,
                "property", "ArrayOfCodeSystemProperty",
                parentResourceDetail, resourceChanges, dispatch, conceptSelected)
        }
    }, [codeSystemTermState.property]);

    useEffect(() => {
        if (editMode && resourceJson && conceptPathIndexes && conceptPath.length > 0) {
            updateCodeSystemConceptElement(codeSystemTermState, conceptPathIndexes,
                "concept", "ArrayOfCodeSystemConcept",
                parentResourceDetail, resourceChanges, dispatch, conceptSelected)
        }
    }, [codeSystemTermState.concept]);

    useEffect(() => {
        if (codeSystemTermConceptState.length > 0) {
            setCodeSystemTermState(prevState => {
                return { ...prevState, "concept": codeSystemTermConceptState };
            });
        }
    }, [codeSystemTermConceptState]);

    useEffect(() => {
        if (submitNewChildConcepts === true &&
            newChildConcepts.length > 0) {
            setCodeSystemTermConceptState(prevState => {
                let newArray = prevState.concat(newChildConcepts);
                return newArray;
            });
            dispatch(changeSubmitNewChildConcepts(false));
            dispatch(changeNewChildConcepts([]));
        }
    }, [submitNewChildConcepts]);

    useEffect(() => {
        if (submitNewTopLevelConcepts === true &&
            newChildConcepts.length > 0 && editMode && resourceJson) {
            let newCodeSystemConceptArray = codeSystemTermConceptState.concat(newChildConcepts);
            let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = newResourceDetail.resourceJson.concept;
            previousFinalValue = newResourceDetail.revisedResourceJson.concept;
            newResourceDetail.revisedResourceJson.concept = newCodeSystemConceptArray;
            if (newCodeSystemConceptArray !== undefined &&
                JSON.stringify(previousFinalValue) !== JSON.stringify(newCodeSystemConceptArray)) {
                console.log("resourceUpdate for CodeSystem.concept");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, newResourceDetail.id,
                    "ArrayOfCodeSystemConcept",
                    "concept",
                    previousInitialValue,
                    newCodeSystemConceptArray);
            }
            dispatch(changeSubmitNewTopLevelConcepts(false));
            dispatch(changeNewChildConcepts([]));
        }
    }, [submitNewTopLevelConcepts]);

    return <div>
        <div style={{ marginTop: "12px" }}>
            {conceptPath?.length > 0 ?
                <>
                    {conceptDelete === true ?
                        <>
                            <h1 style={{ color: "#FF0000" }}>
                                Concept "{conceptName}" deletion pending, please click "Update" to complete deletion.
                            </h1>
                        </>
                        :
                        <>
                            <h2 style={{ margin: "0px" }}>{conceptName}</h2>
                            <CodeSystemConceptDataEntry resourceId={resourceId}
                                codeSystemTermState={codeSystemTermState}
                                setCodeSystemTermState={setCodeSystemTermState} />
                            <br /><br />
                        </>
                    }
                </>
                :
                <>
                    <span className="instructionText">
                        <span>Please select a term</span>
                        <br />
                        <br />
                    </span>
                    <ChildConceptsTable resourceId={resourceId} />
                    <br />
                </>
            }
        </div>
    </div>
}

export default CodeSystemTermEdit;
export { CodeSystemConceptDesignationEntry };